import "./_gallery-slider-styles.scss";

import "./view";
